/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { useState, useEffect } from 'react';
import { string, object, bool, func } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import Select from 'components/Form/Input/Select/Select';
import InformationBox from 'components/InformationBox/InformationBox';

import styles from './select-job.scss';

/**
 * This is the SelectJob component class.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */

const SelectJob = ({ jobs: { items }, job, valid, value, onChange }) => {
  const [options, setOptions] = useState({});

  const onChangeInput = event => {
    const {
      target: { name, value },
    } = event;

    onChange(null, name, value);
  };

  useEffect(() => {
    const list = {};

    items.forEach(({ title, job_id }) => {
      list[job_id] = title;
    });

    setOptions(list);
  }, [items]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.input}>
        <label htmlFor="job_id_or_code" className={styles.title}>
          {p.t('jobs.send_requests.form.job_id_or_code.label')}
        </label>

        <div className={styles.project}>
          <div className={styles.select}>
            <Select
              id="job_id_or_code"
              name="job_id_or_code"
              placeholder={p.t(
                'jobs.send_requests.form.job_id_or_code.placeholder'
              )}
              value={value}
              error={!valid}
              options={options}
              onChange={onChangeInput}
              required
            />
          </div>

          {job?.job_id && (
            <div className={styles.projectData}>
              <InformationBox title="Dates:" text={job?.job_dates} />
              <InformationBox title="Location:" text={job?.location} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
SelectJob.propTypes = {
  jobs: object.isRequired,
  job: object.isRequired,
  value: string,
  valid: bool,
  onChange: func,
};

/**
 * Declare default props.
 *
 * @type {Object}
 */
SelectJob.defaultProps = {
  value: '',
  valid: true,
  onChange: () => {},
};

export default connect(({ jobs, job }) => ({ jobs, job }))(SelectJob);
